// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockWrapper_wrapper__uDK4F","content":"BlockWrapper_content__HZtft"};